import Carousel, {
  type EmblaOptionsType,
  type EmblaPluginType,
} from "embla-carousel";
import "./carousel.css";

export const createCarousel = (
  container: HTMLElement,
  options?: EmblaOptionsType,
  userPlugins?: EmblaPluginType[],
) => {
  const carousel = Carousel(
    container,
    {
      slidesToScroll: 1,
      skipSnaps: true,
      ...options,
    },
    userPlugins,
  );

  const prev = container?.querySelector<HTMLElement>(".carousel-nav-prev");
  const next = container?.querySelector<HTMLElement>(".carousel-nav-next");

  const noop = (event: Event) => event.stopPropagation();

  prev?.addEventListener("mousedown", noop);
  next?.addEventListener("mousedown", noop);
  prev?.addEventListener("touchstart", noop);
  next?.addEventListener("touchstart", noop);

  prev?.addEventListener("click", (event) => {
    event.stopPropagation();
    carousel.goToPrev();
  });

  next?.addEventListener("click", async (event) => {
    event.stopPropagation();
    carousel.goToNext();
  });

  const updateUI = () => {
    prev?.classList.toggle("btn-disabled", carousel.canGoToPrev() === false);
    next?.classList.toggle("btn-disabled", carousel.canGoToNext() === false);
    container.classList.toggle(
      "is-prev-available",
      carousel.canGoToPrev() === true,
    );
    container.classList.toggle(
      "is-next-available",
      carousel.canGoToNext() === true,
    );
  };

  carousel.on("select", updateUI);
  carousel.on("resize", updateUI);

  updateUI();

  return carousel;
};
